<template>
  <scroll-bar>
    <el-menu
      mode="vertical"
      :show-timeout="200"
      :default-active="$route.path"
      :collapse="isCollapse"
      :unique-opened = true
      background-color="#304156"
      text-color="#bfcbd9"
      active-text-color="#FCAA25">
      <sidebar-item :routes="routes"></sidebar-item>
    </el-menu>
  </scroll-bar>
</template>

<script>
import { mapGetters } from 'vuex'
import SidebarItem from './SidebarItem'
import ScrollBar from '@/components/ScrollBar'

export default {
  components: { SidebarItem, ScrollBar },
  computed: {
    ...mapGetters([
      'sidebar',
      'routers',
      'userInfo',
    ]),
    routes() {
      // 对商户的订单菜单做特殊处理
      if ( this.userInfo && this.userInfo.userType === 'seller' ) {
        return this.setSellerOrderNaming( this.routers );
      } else {
        return this.routers;
      }
    },
    isCollapse() {
      return !this.sidebar.opened
    }
  },
  methods: {
    /*
      在商户的情况
      收款订单管理 改为 支付订单管理
      付款订单管理 改为 提现订单管理
    */
    setSellerOrderNaming( routers ) {
      if ( routers ) {
        routers.forEach(function( part, index, routersArray ) {
          if ( part.children && part.meta && part.meta.title === '订单管理' ) {
            part.children.forEach(function(p, i) {
              switch ( p.meta && p.meta.title ) {
                case '收款订单管理':
                  routersArray[index].children[i].meta.title = "支付订单管理";
                  break;
                case '付款订单管理':
                  routersArray[index].children[i].meta.title = "提现订单管理";
                  break;
              }
            });
          }
        });
      }

      return routers;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/index.vue